import { noRegistryFunctionReturn } from 'config/errors';
import { warnIfDebug } from 'utils/log';
import { findInstance } from 'shared/registry';
import { hasOwn } from 'utils/object';
import { isFunction, isString } from 'utils/is';

// finds the component constructor in the registry or view hierarchy registries
export default function getComponentConstructor(blcktive, name) {
  const instance = findInstance('components', blcktive, name);
  let Component;

  if (instance) {
    Component = instance.components[name];

    if (Component && !Component.isInstance) {
      if (Component.default && Component.default.isInstance) Component = Component.default;
      else if (!Component.then && isFunction(Component)) {
        // function option, execute and store for reset
        const fn = Component.bind(instance);
        fn.isOwner = hasOwn(instance.components, name);
        Component = fn();

        if (!Component) {
          warnIfDebug(noRegistryFunctionReturn, name, 'component', 'component', {
            blcktive
          });
          return;
        }

        if (isString(Component)) {
          // allow string lookup
          Component = getComponentConstructor(blcktive, Component);
        }

        Component._fn = fn;
        instance.components[name] = Component;
      }
    }
  }

  return Component;
}
